import { apiRequestObject } from "./elasticpress";

jQuery(document).ready(function ($) {
  class Search {
    // 1. describe and create/initiate our object
    constructor(searchField, resultsDiv) {
      this.searchField = $(searchField);
      this.resultsDiv = $(resultsDiv);
      this.events();
      this.previousValue;
      this.typingTimer;
    }

    // 2. events
    events() {
      this.searchField.on("keyup", this.typingLogic.bind(this));
      $(document).on("click", this.hideResults.bind(this));
    }

    // 3. methods (function, action...)
    typingLogic() {
      if (this.searchField.val() != this.previousValue) {
        clearTimeout(this.typingTimer);

        if (this.searchField.val()) {
          this.typingTimer = setTimeout(this.getResults.bind(this), 50);
        } else {
          this.resultsDiv.html("");
        }
      }

      this.previousValue = this.searchField.val();
    }

    hideResults(e) {
      if (!$(e.target).closest(".header-search-wrapper").length) {
        this.resultsDiv.html("");
      }
    }

    highlightTerm() {
      let searchTerm = this.searchField.val();
      let tempResultsDiv = this.resultsDiv.html();
      const regex = new RegExp(">([^<]*)?(" + searchTerm + ")([^>]*)?<", "ig");

      // Inject span with class of 'current-term' for any matches
      this.resultsDiv.html(
        tempResultsDiv.replace(
          regex,
          '>$1<span class="current-term">$2</span>$3<'
        )
      );
      // Once results have been fetched update media urls if needed
      this.updateAttachmentUrls();
    }

    getResults() {
      let searchTerm = this.searchField.val();
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("ep-search-term", searchTerm);

      const rawDynamic = JSON.stringify(apiRequestObject(searchTerm));

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: rawDynamic,
        redirect: "follow",
      };

      // EP uses a domain marker in the endpoint url specific to that domain. Using a different one will cause a search user to go to a different environment
      const hostname = window.location.hostname;
      // Removes all non alphanumeric chars from the hostname as is the paradigm for EP endpoints, also removes www as that gets omitted
      let environment = hostname.replace(/\W/g, "");
      // Replace www if it exists as EP strips that out
      environment = environment.replace("www", "");
      const url = `https://steven-farley-601178cb214a1.clients.hosted-elasticpress.io/steven-farley-601178cb214a1--${environment}-post-1/autosuggest`;

      fetch(url, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          let articles = result.hits.hits.filter(
            (item) => item._source.post_type === "article"
          );
          let media = result.hits.hits.filter(
            (item) => item._source.post_type === "attachment"
          );
          let publicMedia = media.filter(
            (item) =>
              item._source.meta.public_image &&
              item._source.meta.public_image[0].raw == "1"
          );
          let pages = result.hits.hits.filter(
            (item) => item._source.post_type === "page"
          );
          let collections = result.hits.hits.filter(
            (item) => item._source.post_type === "collection"
          );
          let exhibitions = result.hits.hits.filter(
            (item) => item._source.post_type === "exhibition"
          );
          let staff = result.hits.hits.filter(
            (item) => item._source.post_type === "staff"
          );
          let standards = result.hits.hits.filter(
            (item) => item._source.post_type === "georgia-standard"
          );
          let topics = result.hits.hits.filter(
            (item) => item._source.post_type === "topic"
          );

          let articlesDiv = "";

          if (articles.length) {
            articlesDiv = `
              <div class="ac-heading">
                <span>Articles</span>
              </div>
              ${articles
                .filter((_val, i) => i < 2)
                .map(
                  (item) => `
                <a href="${item._source.permalink}" class="ac-result">
                  <div class="ac-result-text">
                    <h4 class="ac-result-title">
                      ${item._source.post_title}
                    </h4>
                    <span class="ac-result-meta">
                      ${item._source.meta.subtitle?.[0].value ?? ""}
                    </span>
                  </div>
                </a>
              `
                )
                .join("")}
            `;

            if (articles.length > 3) {
              articlesDiv += `
                <div class="ac-more">
                  <a href="/?s=${searchTerm}">${articles.length - 2} more...</a>
                </div>
              `;
            }
          }

          let mediaDiv = "";

          if (publicMedia.length) {
            mediaDiv = `
              <div class="ac-heading">
                <span>Media</span>
              </div>
              ${publicMedia
                .filter((val, i) => i < 2)
                .map(
                  (item) => `
                <a href="${item._source.permalink}" class="ac-result">

                  <div class="ac-result-image" data-id="${item._source.ID}">
                  </div>
                  <div class="ac-result-text">
                    <h4 class="ac-result-title">${item._source.post_title}</h4>
                  </div>
                </a>
              `
                )
                .join("")}
            `;

            if (publicMedia.length > 3) {
              mediaDiv += `
                <div class="ac-more">
                  <a href="/?s=${searchTerm}&tab=Media">${
                publicMedia.length - 2
              } more...</a>
                </div>
              `;
            }
          }

          let topicsDiv = "";

          if (topics.length) {
            topicsDiv = `
              <div class="ac-heading">
                <span>Topics</span>
              </div>
              ${topics
                .filter((_val, i) => i < 2)
                .map(
                  (item) => `
                <a href="${item._source.permalink}" class="ac-result">
                  <div class="ac-result-text">
                    <h4 class="ac-result-title">
                      ${item._source.post_title}
                    </h4>
                    <span class="ac-result-meta">
                      ${item._source.meta.subtitle?.[0].value ?? ""}
                    </span>
                  </div>
                </a>
              `
                )
                .join("")}
            `;

            if (topics.length > 3) {
              topicsDiv += `
                <div class="ac-more">
                  <a href="/?s=${searchTerm}">${topics.length - 2} more...</a>
                </div>
              `;
            }
          }

          let exhibitionsDiv = "";

          if (exhibitions.length) {
            exhibitionsDiv = `
              <div class="ac-heading">
                <span>Exhibitions</span>
              </div>
              ${exhibitions
                .filter((val, i) => i < 2)
                .map(
                  (item) => `
                <a href="${item._source.permalink}" class="ac-result">
                  <div class="ac-result-text">
                    <h4 class="ac-result-title">
                      ${item._source.post_title}
                    </h4>
                  </div>
                </a>
              `
                )
                .join("")}
            `;

            if (exhibitions.length > 3) {
              exhibitionsDiv += `
                <div class="ac-more">
                  <a href="/?s=${searchTerm}&tab=Exhibitions">${
                exhibitions.length - 2
              } more...</a>
                </div>
              `;
            }
          }

          let collectionsDiv = "";

          if (collections.length) {
            collectionsDiv = `
              <div class="ac-heading">
                <span>Collections</span>
              </div>
              ${collections
                .filter((val, i) => i < 2)
                .map(
                  (item) => `
                <a href="${item._source.permalink}" class="ac-result">
                  <div class="ac-result-text">
                    <h4 class="ac-result-title">
                      ${item._source.post_title}
                    </h4>
                  </div>
                </a>
              `
                )
                .join("")}
            `;

            if (collections.length > 3) {
              collectionsDiv += `
                <div class="ac-more">
                  <a href="/?s=${searchTerm}&tab=Collections">${
                collections.length - 2
              } more...</a>
                </div>
              `;
            }
          }

          let standardsDiv = "";

          if (standards.length) {
            standardsDiv = `
              <div class="ac-heading">
                <span>Standards</span>
              </div>
              ${standards
                .filter((_val, i) => i < 2)
                .map(
                  (item) => `
                <a href="${item._source.permalink}" class="ac-result">
                  <div class="ac-result-text">
                    <h4 class="ac-result-title">
                      ${item._source.post_title}
                    </h4>
                    <span class="ac-result-meta">
                      ${(item._source.meta.objective?.[0].value ?? "").replace(
                        /<a\b[^>]*>(.*?)<\/a>/i,
                        ""
                      )}
                    </span>
                  </div>
                </a>
              `
                )
                .join("")}
            `;

            if (standards.length > 3) {
              standardsDiv += `
              <div class="ac-more">
                <a href="/?s=${searchTerm}&tab=Standards">${
                standards.length - 2
              } more...</a>
              </div>
              `;
            }
          }

          let staffDiv = "";

          if (staff.length) {
            staffDiv = `
              <div class="ac-heading">
                <span>Authors</span>
              </div>
              ${staff
                .filter((val, i) => i < 2)
                .map(
                  (item) => `
                <a href="${item._source.permalink}" class="ac-result">
                  <div class="ac-result-text">
                    <h4 class="ac-result-title">
                      ${item._source.post_title}
                    </h4>
                  </div>
                </a>
              `
                )
                .join("")}
            `;

            if (staff.length > 3) {
              staffDiv += `
              <div class="ac-more">
                <a href="/?s=${searchTerm}">${staff.length - 2} more...</a>
              </div>
              `;
            }
          }

          this.resultsDiv.html(`
            ${articlesDiv}
            ${mediaDiv}
            ${topicsDiv}
            ${exhibitionsDiv}
            ${collectionsDiv}
            ${standardsDiv}
            ${staffDiv}
          `);
        })
        .then(this.highlightTerm.bind(this))
        .catch((error) => console.log("error", error));
    }

    // Look at the results and update the media preview results with the correct urls. Autosuggest results do not contain these urls, and though we use the guid initially to populate as this can
    // often be relied on it isn't guaranteed. This will handle the remaining cases
    updateAttachmentUrls() {
      const updatedResults = this.resultsDiv[0];
      const imageElements = Array.from(
        updatedResults.querySelectorAll("[data-id]")
      );
      const ids = imageElements.map((image) => image.dataset.id);
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      fetch(`${LOCALIZED.rest_url}hive/v1/get-media-urls`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          ids: JSON.stringify(ids),
        }),
      })
        .then((response) => response.json())
        .then((result) => {
          const parsedResult = JSON.parse(result);
          imageElements.forEach((element) => {
            const attachmentUrl = parsedResult[element.dataset.id];
            if (attachmentUrl) {
              element.style.backgroundImage = `url("${attachmentUrl}")`;
            }
          });
        });
    }
  }

  const headerSearch = new Search(
    ".site-header .search-field",
    ".site-header .ac"
  );
  const homeSearch = new Search(
    ".page-header-search .search-form-input",
    ".page-header-search .ac"
  );
});
